/** Available `serde` environment types */
export enum SerdeEnvironmentEnum {
  /** Backend side environment - additional async checks can be used */
  BACKEND = 'BACKEND',
  /** Frontend side environment - only sync transforms and validations can be used*/
  FRONTEND = 'FRONTEND',
}
